<template>
  <div id="app-root">
    <Header />
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="page-fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <Footer />
  </div>
</template>

<script>
import { useStore } from "vuex";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { onBeforeMount, ref } from "@vue/runtime-core";
export default {
  components: {
    Header,
    Footer,
  },
  setup() {
    const store = useStore();
    const state = ref("pc");
    const setMode = () => {
      let w = document.documentElement.clientWidth;
      if (w > 960) {
        state.value = "pc";
        store.state.client === "mobile" ? store.commit("setWidth", "pc") : null;
        return;
      }
      state.value = "mobile";
      store.state.client === "pc" ? store.commit("setWidth", "mobile") : null;
    };
    onBeforeMount(setMode);
    window.addEventListener("resize", setMode);
    return {
      state,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables';

#app-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}

// Page transition: fade + slight upward slide
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}
.page-fade-enter-from {
  opacity: 0;
  transform: translateY(12px);
}
.page-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
